import { Toaster } from "sonner";
import { Router } from "./routes/Router";
import { EntitlementProvider } from "./contexts/EntitlementContext";
import { TooltipProvider } from "./components/ui/tooltip";

function App() {
  return (
    <EntitlementProvider>
      {/* Single app-wide tooltip provider. Call sites must NOT wrap their own:
          before this existed every tooltip needed a local provider, and the ones
          that forgot silently never rendered. */}
      <TooltipProvider delayDuration={200}>
        <Router />
      </TooltipProvider>
      <Toaster richColors theme="dark" position="bottom-right" />
    </EntitlementProvider>
  );
}

export default App;
